import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { Sidebar } from '@lib/sidebar';

import { Auth, Lambda } from '../service';
import { Settings } from '../service/settings';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [
    Sidebar,
    MatToolbarModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    MatSidenavModule,
    MatButtonModule,
    MatChipsModule,
  ],
  template: `
    <mat-toolbar color="primary">
      <div class="logo">
        <a routerLink="/"> <span class="link-logo-highlight">LINK</span>DIGITAL Contracts Manager </a>
        @if (isDev()) {
          <mat-chip>DEV</mat-chip>
        }
      </div>
      <span class="spacer"></span>

      @if (theme() === 'dark') {
        <button mat-icon-button matTooltip="Switch to light theme" (click)="theme.set('light')">
          <mat-icon>light_mode</mat-icon>
        </button>
      } @else if (theme() === 'light') {
        <button mat-icon-button matTooltip="Switch to dark theme" (click)="theme.set('dark')">
          <mat-icon>dark_mode</mat-icon>
        </button>
      }

      @if (auth.isLoggedIn()) {
        <button mat-icon-button matTooltip="Toggle sidebar" (click)="showSidebar.update((value) => !value)">
          <mat-icon>corporate_fare</mat-icon>
        </button>

        <button mat-icon-button [matTooltip]="auth.name() + '&#10;' + auth.email() || ''">
          <mat-icon>person</mat-icon>
        </button>

        <a color="warn" (click)="logout()" matTooltip="Logout" routerLink="/login" mat-icon-button>
          <mat-icon>power_settings_new</mat-icon>
        </a>
      }
    </mat-toolbar>
    <mat-sidenav-container>
      @if (auth.isLoggedIn()) {
        <mat-sidenav
          [opened]="showSidebar()"
          mode="side"
          class="mat-bg-secondary-container mat-text-on-secondary-container"
        >
          <lcm-sidebar></lcm-sidebar>
        </mat-sidenav>
      }
      <mat-sidenav-content>
        <main id="content" role="main">
          <router-outlet></router-outlet>
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  styles: [
    '.link-logo-highlight { font-weight: bold; color: #17cbe2; }',
    '.mat-drawer-container {background: transparent;}',
  ],
})
export class Layout {
  readonly showSidebar = inject(Settings).sidebarOpen;

  readonly auth = inject(Auth);
  readonly theme = inject(Settings).theme;

  isDev = inject(Lambda).isDev;
  logout() {
    this.auth.logout();
  }
}
